import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import Arrow from "../arrow"

export const LeftArrow = styled(Arrow)`
  text-align: left;
  font-weight: bold;
  cursor: pointer;
  display: inline-block;
  width: 50%;

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}

  ${breakpoint("tablet")`
    display: block;
    width: unset;
  `}
`

export const RightArrow = styled(Arrow)`
  text-align: right;
  font-weight: bold;
  cursor: pointer;
  display: inline-block;
  width: 50%;

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}

  ${breakpoint("tablet")`
    display: block;
    width: unset;
  `}
`

export const Timeslot = styled.button`
  appearance: none;
  padding: 0.5rem 1.75rem;
  border-radius: 0.5rem;
  border: ${({ selected }) => (!!selected ? "transparent" : "2px solid #fff")};
  box-shadow: none;
  font-size: 0.8rem;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  color: #fff;
  background-color: ${({ selected, theme }) => (!!selected ? theme.colors.availability.booked : "transparent")};
  margin: 0;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
  min-height: 38px;
  min-width: 6rem;

  background-color: ${(props) =>
    props.booked_slot ? ({ theme }) => theme.colors.availability.booked + " !important" : ""};
  background-color: ${(props) => (props.selected_slot ? ({ theme }) => "#fff" : "")};
  opacity: ${(props) => (props.restricted_slot || props.booked_elsewhere_slot ? 0.3 : "")};
  opacity: ${(props) => (props.selected ? 1 + " !important" : "")};

  color: ${(props) => (props.booked_slot ? "#fff !important" : "")};
  color: ${(props) =>
    props.selected_slot ? ({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary : ""};

  &:not([disabled]):hover {
    color: #000;
    background-color: #fff;
    opacity: 0.8;
  }

  &[disabled],
  &:disabled {
    pointer-events: none;
  }
`

export const Div = styled.div`
  display: block;
  width: 100%;
  margin-left: 0;
  margin-bottom: 2rem;

  ${breakpoint("tablet")`
    margin-left: 2rem;
  `}
`

export const Ul = styled.ul`
  list-style-type: none;
  padding: 0;
`

export const Li = styled.li`
  color: #fff;
  display: inline;
  font-weight: 400;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-size: 0.8rem;
  margin-right: 1rem;
`
export const BoxNotSelected = styled.span`
  border: 2px solid #fff;
  border-radius: 4px;
  background: transparent;
  display: table-cell;
  height: 12px;
  width: 12px;
`

export const BoxSelected = styled.span`
  border-radius: 4px;
  border: 2px solid #fff;
  background: #fff;
  display: table-cell;
  height: 12px;
  width: 12px;
`

export const BoxBooked = styled.span`
  border-radius: 5px;
  border: 2px solid ${({ theme }) => theme.colors.availability.booked};
  background-color: ${({ theme }) => theme.colors.availability.booked};
  display: table-cell;
  height: 12px;
  width: 12px;
`

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.body};
`
